import React from "react";
import { Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { Upload } from "@formily/antd";

function AttachmentUpload({ onChange, ...props }) {
  return (
    <Upload
      {...props}
      name="upload"
      action="/api/announcement/attachments/"
      headers={{
        Authorization: `Token ${props.token.token}`,
      }}
      onChange={(v) => {
        onChange(v);
      }}
    >
      <Button icon={<UploadOutlined />}>上传附件</Button>
    </Upload>
  );
}

export default AttachmentUpload;
